import { faBowlChopsticks, faPlus } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Icon } from '@feathr/components';
import Page from '@feathr/extender/App/Page';
import { GeoFilterDefaultModal, GeoFilterModal, useModals } from '@feathr/extender/components';

import GeoFiltersTable from './GeoFiltersTable';

import * as styles from './GeoFiltersPage.css';

function GeoFiltersPage(): JSX.Element {
  const { t } = useTranslation();

  const { editCreate, defaultGeoSet } = useModals();

  return (
    <Page
      actions={[
        // TODO: Remove "Set default" button. This is here for you, the smoke tester, until I have the tables up.
        <Button
          key={'assign-default'}
          onClick={defaultGeoSet.open}
          prefix={<Icon icon={faBowlChopsticks} />}
        >
          {t('Assign as default')}
        </Button>,
        // TODO: Remove "Edit set" button. This is here for you, the smoke tester, until I have the tables up.
        <Button
          key={'edit-set'}
          onClick={editCreate.handleOpen('edit')}
          prefix={<Icon icon={faPlus} />}
        >
          {t('Edit set')}
        </Button>,

        <Button
          key={'create-set'}
          onClick={editCreate.handleOpen('create')}
          prefix={<Icon icon={faPlus} />}
          type={'primary'}
        >
          {t('Create set')}
        </Button>,
      ]}
      collapseHeader={false}
      collapseHeaderOnScroll={true}
      contentClassName={styles.pageContent}
      description={t(
        'Create and manage geofilter sets that allow you to target your campaigns by location. These sets can be used across ad campaigns.',
      )}
      showHeader={true}
      title={'Geofilters'}
    >
      <GeoFilterModal
        context={editCreate.context}
        onClose={editCreate.close}
        opened={editCreate.isOpen}
      />
      <GeoFilterDefaultModal
        // TODO: Pass the correct geoFilterName
        geoFilterName={t('Tokyo Metropolis')}
        onClose={defaultGeoSet.close}
        opened={defaultGeoSet.isOpen}
      />
      <GeoFiltersTable onCreateSet={editCreate.handleOpen('create')} />
    </Page>
  );
}

export default GeoFiltersPage;
